/**
 * Solo propietario y gerente: el personal vuelve a la pantalla de Órdenes (spec 012).
 * Envuelve una página (children) o un grupo de rutas (Outlet).
 */

import { Navigate, Outlet } from 'react-router-dom';
import { useAdminAuth } from '@/stores/adminAuthStore';
import { AdminPermissions } from '@/types/admin';
import { ORDERS_PATH } from '@/utils/adminHome';

interface ManagerOnlyRouteProps {
  children?: React.ReactNode;
}

export function ManagerOnlyRoute({ children }: ManagerOnlyRouteProps) {
  const { admin } = useAdminAuth();

  if (!admin || !AdminPermissions.canManageItems(admin.role)) {
    return <Navigate to={ORDERS_PATH} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
}
